import { MonoTypeOperatorFunction } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

export function distinctUntilChangedJson<T>(): MonoTypeOperatorFunction<T> {
  return distinctUntilChanged(null, JSON.stringify);
}
